import { render, staticRenderFns } from "./OrderSKuList.vue?vue&type=template&id=23b847bd&scoped=true&"
import script from "./OrderSKuList.vue?vue&type=script&lang=js&"
export * from "./OrderSKuList.vue?vue&type=script&lang=js&"
import style0 from "./OrderSKuList.vue?vue&type=style&index=0&id=23b847bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b847bd",
  null
  
)

export default component.exports